import { type ReactNode } from 'react';

import { startedOutreachHref } from '@apps/web/features/phoebe_chat_v3/api/outreach_api';
import { useOutreachCardStatus } from '@apps/web/features/phoebe_chat_v3/api/outreach_api';
import { type HarnessScope } from '@apps/web/features/phoebe_chat_v3/model/event_types';
import { type OutreachCardHeading } from '@apps/web/features/phoebe_chat_v3/model/outreach_card_status';
import { OutreachStatusCard } from '@apps/web/features/phoebe_chat_v3/ui/primitives/outreach_status_card';

export function LiveOutreachCard({
    scope,
    outreachId,
    heading,
}: Readonly<{
    scope: HarnessScope;
    outreachId: string;
    heading: OutreachCardHeading;
}>): ReactNode {
    const outreach = useOutreachCardStatus(scope, outreachId);
    return (
        <OutreachStatusCard
            heading={heading}
            status={outreach.hasRequestFailed ? 'unavailable' : outreach.data}
            viewHref={startedOutreachHref(outreachId, scope)}
        />
    );
}
